import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		reportInfo: {
            rptKey: "",
            tenant: '',
            localizedItemTxt: ""
        }, // 报表相关信息
        reportSearchFilter: [], // 动态搜索组件
        dataList: [], // 新报表--列表数据
        loading: false, // 新报表--列表是否在加载中
        series: [], // 新报表--导出excel的维度配置项
	},
	mutations: {
		// 报表相关信息
		SETREPORTINFO(state, value) {
			state.reportInfo = value;
		},
		// 报表搜索动态组件
		SETREPORTSEARCHFILTER(state, value) {
			if(!value) {
				state.reportSearchFilter = [];
				return false;
			}
			state.reportSearchFilter = value;
        },
        // 新报表--列表数据
        SETDATALIST(state, value) {
            state.dataList = value;
        },
        // 新报表--列表是否在加载中
        SETLOADING(state, value) {
            state.loading = value;
        },
        // 新报表--导出excel的维度配置项
        SETSERIES(state, value) {
            state.series = value;
        }
	},
	actions: {},
	modules: {}
})